export const SERVICE_CATALOG_PATH_PREFIX = "/service-catalog";

export const isSuperUser = (user) => user?.role === "super_user";

export const isServiceCatalogPath = (path = "") =>
  String(path).startsWith(SERVICE_CATALOG_PATH_PREFIX);

export const getUserPageAccess = (user) => {
  return {};
};

export const hasPageAccess = (user, pageKey) => {
  if (isSuperUser(user)) return true;

  const isAdmin =
    user?.is_property_manager_admin || user?.is_corporate_accounting_admin;

  // Always allow access to settings, invite, api_credentials, and glcode for admins
  // Also allow them if the user has explicit 'settings' permission
  const isUtilityPage = [
    "settings",
    "invite",
    "api_credentials",
    "glcode",
  ].includes(pageKey);
  if (isAdmin && isUtilityPage) {
    return true;
  }

  if (isUtilityPage && user?.allowed_page_keys?.includes("settings")) {
    return true;
  }

  if (!user?.allowed_page_keys) {
    // Fallback if backend does not provide permission array yet
    return true;
  }

  return user.allowed_page_keys.includes(pageKey);
};

export const getFirstAccessiblePath = (user, fallbackPath = "/profile") => {
  if (isSuperUser(user)) return SERVICE_CATALOG_PATH_PREFIX;

  if (hasPageAccess(user, "portfolio_dashboard")) {
    return "/portfolio-dashboard";
  }

  if (hasPageAccess(user, "chatbot_analytics")) {
    return "/chatbot-analytics";
  }

  return fallbackPath;
};

export const filterMenuItemsByAccess = (menuItems, user) => {
  if (isSuperUser(user)) return menuItems;

  return menuItems
    .map((item) => {
      // If it has subItems, filter those first
      if (item.subItems) {
        const filteredSubItems = item.subItems.filter((sub) =>
          hasPageAccess(user, sub.pageKey)
        );
        // Only return the parent if it still has subItems
        if (filteredSubItems.length > 0) {
          return { ...item, subItems: filteredSubItems };
        }
        // If all subItems were filtered out, hide the parent too
        return null;
      }

      // For items without subItems, check access directly
      if (item.pageKey && !hasPageAccess(user, item.pageKey)) {
        return null;
      }

      return item;
    })
    .filter(Boolean); // Remove null items
};
